import React from 'react';
import { connect } from 'react-redux';
import jwtDecode from 'jwt-decode';
import ErrorBoundary from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';
import { getTenantPages } from './tenant/tenantPages';
import Flow from './flow';
import Build from './build';
import Players from './player/players';
import Package from './package';
import Assets from './assets';
import DragContext from '../utils/dragDropContext';
import MacroEditor from './macro-editor';
import Dashboard from './dashboard/Dashboard';
import AllNotifications from './userNotifications/AllNotifications';
import FlowList from './flow/FlowList';
import { isSubtenant, generateRouteUrl, generateRandomString } from '../utils/core';
import FlowLibrary from './flowlibrary/FlowLibrary';
import PageSwitcher from './generic/PageSwitcher';
import '../../css/admin.less';
import '../../css/modal.less';
import ServiceController from './services/ServiceController';
import { getFlag } from '../config/flags';
import InitialOrgPage from './flowOrganization/InitialOrgPage';
import { notify } from '../utils/errors';
import AuditLogs from './auditLogs/AuditLogs';

import { navigate } from '@reach/router';
import UserSettings from './userSettings/UserSettings';
import classnames from 'classnames';

class Admin extends React.Component {

    constructor(props) {
        super(props);

        this.state = { restartFlow: false };

        this.openPageLayout = this.openPageLayout.bind(this);
        this.errorHandler = this.errorHandler.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ restartFlow: !this.props.isActive && nextProps.isActive });
    }

    openPageLayout(callback, response) {
        const page = manywho.utils.getObjectDataProperty(response.outputs, 'Selected Page');
        const command = manywho.utils.getObjectDataProperty(response.outputs, 'Command').contentValue;

        if (manywho.utils.isEqual(command, 'new', true)) {
            const route = generateRouteUrl({
                tabType: 'new_page',
                tenantId: this.props.tenantId,
                options: {
                    tabKey: generateRandomString(16),
                },
            });

            navigate(route);

        } else if (manywho.utils.isEqual(command, 'edit', true)) {

            const route = generateRouteUrl({
                tabType: 'page',
                tenantId: this.props.tenantId,
                options: {
                    pageId: manywho.utils.getObjectDataProperty(page.objectData[0].properties, 'id').contentValue,
                },
            });

            navigate(route);
        }
    }

    errorHandler(error, info) {
        notify({
            error,
            params: {
                tenantId: this.props.tenantId,
                componentStack: info,
                
            },
        });
    }

    render() {
        const { authenticationToken, tenantId, tenantName } = this.props;
        
        if (!tenantId) return null;

        let content = null;
        let inputs = null;

        const currentTenantIsSubtenant = isSubtenant(tenantName);

        const options = {
            outcomes: {
                isFixed: true,
            },
        };

        const AssetsWithDragContext = DragContext(Assets);

        switch (this.props.view) {

        case 'audit':
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    <AuditLogs authenticationToken={authenticationToken} tenantId={tenantId} />
                </ErrorBoundary>
            );
            break;

        case 'tenant':
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    <PageSwitcher pages={getTenantPages(currentTenantIsSubtenant)} authenticationToken={authenticationToken} />
                </ErrorBoundary>
            );
            break;

        case 'flows':
            inputs = [{ FlowId: '' }];
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    <FlowList
                        adminTenantId={this.props.adminTenantId}
                        tenantId={tenantId}
                        inputs={inputs}
                        options={options}
                        restart={this.state.restartFlow}
                        authToken={authenticationToken}
                        isEditorActive={this.props.isActive}
                    />
                </ErrorBoundary>
            );
            break;

        case 'services':
            inputs = [{ FlowId: '' }];
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    {
                        getFlag('services') ?
                            <ServiceController /> :
                            (
                                <Flow
                                    className="hide-empty-labels"
                                    tenantId={this.props.adminTenantId}
                                    flowName="Services"
                                    component="main"
                                    key="services"
                                    inputs={inputs}
                                    options={options}
                                />
                            )
                    }
                </ErrorBoundary>
            );
            break;

        case 'types':
            inputs = [{ FlowId: '' }];
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    <Flow
                        tenantId={this.props.adminTenantId}
                        flowName="Types"
                        component="main"
                        key="types"
                        inputs={inputs}
                        options={options}
                    />
                </ErrorBoundary>
            );
            break;

        case 'values':
            inputs = [
                { FlowId: '' },
                { 'Input TenantId': tenantId },
                { 'Input AuthenticationToken': authenticationToken },
            ];
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    <Flow
                        tenantId={this.props.adminTenantId}
                        flowName="Values"
                        component="main"
                        key="values"
                        inputs={inputs}
                        options={options}
                    />
                </ErrorBoundary>
            );
            break;

        case 'pages':
            inputs = [{ FlowId: '' }];
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    <Flow
                        tenantId={this.props.adminTenantId}
                        flowName="Pages"
                        component="main"
                        key="pages"
                        inputs={inputs}
                        options={options}
                        authenticationToken={authenticationToken}
                        callbacks={this.openPageLayout}
                        restart={this.state.restartFlow}
                    />
                </ErrorBoundary>
            );
            break;

        case 'assets':
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    <AssetsWithDragContext />
                </ErrorBoundary>
            );
            break;
        case 'players':
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    <Players key="players" />
                </ErrorBoundary>
            );
            break;
        case 'build':
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    <Build key="build" />
                </ErrorBoundary>
            );
            break;
        case 'macros':
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    <MacroEditor key="macro-editor" />
                </ErrorBoundary>
            );
            break;
        case 'translate':
            break;
        case 'import-export':
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    <Package adminTenantId={this.props.adminTenantId} key="import-export" />
                </ErrorBoundary>
            );
            break;
        case 'dashboard':
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    <Dashboard />
                </ErrorBoundary>
            );
            break;
        case 'flowlibrary':
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    <FlowLibrary />
                </ErrorBoundary>
            );
            break;
        case 'organization':
            content = (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.errorHandler}>
                    <InitialOrgPage />
                </ErrorBoundary>
            );
            break;
        case 'userNotifications':
            content = <AllNotifications />;
            break;
        case 'userSettings':
            content = <UserSettings />;
            break;

        default:
            content = null;
            break;
        }

        const classes = classnames({
            admin: true,
            active: this.props.isActive,
        });
        return (
            <div className={classes}>
                <span className="admin-transition">
                    {content}
                </span>
            </div>
        );
    }

}

export default connect(
    ({ currentUser }) => { 
        const { authenticationToken } = currentUser;
        let tokenClaims = null;

        if (authenticationToken) {
            tokenClaims = jwtDecode(authenticationToken);
        }

        return {
            authenticationToken, 
            tenantId: tokenClaims?.tenant ?? '',
            tenantName: tokenClaims?.tenant_name ?? '',
        };
    },
)(Admin);
